<!--FastBI产品-->
<template>
  <div class="upgradeDialog">
    <el-dialog
      :before-close="restForm"
      :title="'授权转移'"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="560px"
    >
      <el-form :model="transferData" ref="form" :rules="formRules">
        <el-form-item v-if="requestType =='local'" :label-width="formLabelWidth" :label="firstFormName">
          <el-input v-model="transferData['code']" disabled></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="当前归属伙伴">
          <el-input v-model="transferData['user']" disabled></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="转移伙伴至" prop="toUser">
          <el-input v-model="transferData['toUser']"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form', (visible = false))">取 消</el-button>
        <el-button @click="transferSubmit" type="primary" :disabled="!transferData['toUser']">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import {  Message } from 'element-ui';
import { AFLocalTransfer } from '@/api/afLocal.js';
import { AFCloudTransfer } from '@/api/afCloud.js';

export default {
  data() {
    return {
      visible: false,
      formLabelWidth: '110px',
      formRules: {
        toUser: [
          {
            required: true,
            message: '请输入转移的伙伴',
            trigger: 'blur',
          },
        ],
      },
      transferData: {
        id: '',
        user: '',
        toUser: '',
      },
      requestType: 'local',
      firstFormName: '授权码',
    };
  },
  mounted() {},
  methods: {
    initData(data, type) {
      this.requestType = type;
      const { user_loginname, code, id, domain } = data;

      this.transferData = {
        ...this.transferData,
        user: user_loginname,
        toUser: '',
        code,
        id,
      };
    },
    restForm(done) {
      this.cancel();
      done();
    },
    show() {
      this.visible = true;
    },
    cancel(formName, close) {
      this.transferData = {
        id: '',
        code: '',
        user: '',
        toUser: '',
      };
    },
    async transferSubmit() {
      const { id, toUser } = this.transferData;
      const data = { user: toUser };
      try {
        let transfer = null
        if(this.requestType == 'cloud'){
          transfer = AFCloudTransfer
        }else{
          transfer = AFLocalTransfer
        }
        console.log(id,this.transferData);
        
        const res = await transfer(id,data);
        if (res) {
          Message({
            message: `成功转移至${toUser}`,
            type: 'success',
            duration: 3 * 1000,
          });
          this.visible = false;
          /* 更新表格数据 */
          this.$parent.getAuthData();
        }
      } catch (error) {
        console.warn(error);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/agileFlow/transferDialog.vue